import {  MaxLength, Matches, IsOptional, IsNotEmpty, Max } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class RmIndentQtyLimitDTO {
  @ApiProperty()
  @IsNotEmpty({ message: "rm indent qty limit id should not be empty" })
  @IsOptional()
  rmIndentQtyLimitId: number;

  @ApiProperty()
  @IsNotEmpty()
  date: any;

  @ApiProperty()
  // @Max(151)
  @IsNotEmpty()
  plannedQty: number;


  @ApiProperty()
  // @Max(151)
  @IsNotEmpty()
  indentQty: number;



  @ApiProperty()
  isActive: boolean;

  createdAt: Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Created User allows maximum 50 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
  createdUser: string;

  updatedAt: Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
  updatedUser: string;


  @ApiProperty()
  versionFlag: number;

}